export const Entidades = [
    {
        id: 1,
        name: 'SmartBuy',
        notariales: 100,
        registrales: 75,
        tasacion: 0,
        comisionEstudio: 0,
        comisionActivacion: 0,
        comisionPeriodica: 20,
        portes: 3.5,
        gastosAdm: 3.5,
        seguroDesgravamen: 0.049,
        seguroRiesgo: 0.3,
        periodica: 0
    },
    {
        id: 2,
        name: 'Scotiabank',
        notariales: 150,
        registrales: 15,
        tasacion: 20,
        comisionEstudio: 15,
        comisionActivacion: 15,
        comisionPeriodica: 15,
        portes: 15,
        gastosAdm: 15,
        seguroDesgravamen: 15,
        seguroRiesgo: 15,
        periodica: 0
    },
    {
        id: 3,
        name: 'CreditMax',
        notariales: 120,
        registrales: 50,
        tasacion: 30,
        comisionEstudio: 25,
        comisionActivacion: 20,
        comisionPeriodica: 10,
        portes: 5,
        gastosAdm: 4,
        seguroDesgravamen: 0.045,
        seguroRiesgo: 0.25,
        periodica: 0
    },
    {
        id: 4,
        name: 'BancaRápida',
        notariales: 200,
        registrales: 100,
        tasacion: 50,
        comisionEstudio: 30,
        comisionActivacion: 10,
        comisionPeriodica: 20,
        portes: 7,
        gastosAdm: 6,
        seguroDesgravamen: 0.055,
        seguroRiesgo: 0.35,
        periodica: 0
    },
    {
        id: 5,
        name: 'InversionesSeguras',
        notariales: 90,
        registrales: 70,
        tasacion: 40,
        comisionEstudio: 20,
        comisionActivacion: 5,
        comisionPeriodica: 5,
        portes: 2,
        gastosAdm: 2,
        seguroDesgravamen: 0.04,
        seguroRiesgo: 0.2,
        periodica: 0
    }
]